export class SelectableItem<TData> {
    constructor(data: TData) {
        this.data = data;
        this.selected = false;
    }

    public data: TData;
    public selected: boolean;
}
